module.exports = __webpack_public_path__ + "static/media/29ADMSPC34.8abd5b27.jpg";